export const slugify = (name) => name.toLowerCase().replace(/\s+/g, '-');
export const unslugify = (slug) => slug.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

const CARRIERS = [
  { name: 'MTN', value: 9768, pct: 90.0, color: '#F5C518' },
  { name: 'Vodacom', value: 0, pct: 0, color: '#E62801' },
  { name: 'Others', value: 4136, pct: 10.0, color: '#505050' },
];

const DATA_USAGE = [
  { name: 'MTN', value: 166, color: '#F5C518' },
  { name: 'Vodacom', value: 127, color: '#E62801' },
  { name: 'Others', value: 33, color: '#505050' },
];

const CIRCUITS = [
  { name: 'Bogwasha', count: 55123 },
  { name: 'Malegale', count: 35234 },
  { name: 'Ngwaabe', count: 22678 },
  { name: 'Seotlong', count: 18432 },
  { name: 'Mmashadi', count: 16345 },
  { name: 'Tubatse', count: 12456 },
  { name: 'Leolo', count: 9878 },
  { name: 'Mohlaletse', count: 8974 },
  { name: 'Moroke', count: 7002 },
];

const DEVICE_DETAILS = [
  { imei: '86761506011730', name: 'Mokgotho Khutso', gender: 'Male', school: 'Dikotope', circuit: 'Bogwasha', manufacturer: 'Chuwi', lastSeen: '2y ago', grade: 'Grade 1' },
  { imei: '86761506011874', name: 'Lerato Mokoena', gender: 'Female', school: 'Mabopane', circuit: 'Mabopane', manufacturer: 'Dell', lastSeen: '1y ago', grade: 'Grade 2' },
  { imei: '86761506011735', name: 'Thabo Nkosi', gender: 'Male', school: 'Tembisa', circuit: 'Tembisa', manufacturer: 'HP', lastSeen: '3y ago', grade: 'Grade 3' },
  { imei: '86761506011736', name: 'Naledi Tsosi', gender: 'Female', school: 'Mokopane', circuit: 'Bogwasha', manufacturer: 'Acer', lastSeen: '6m ago', grade: 'Grade 1' },
  { imei: '86761506011737', name: 'Sipho Ndlovu', gender: 'Male', school: 'Mafikeng', circuit: 'Bogwasha', manufacturer: 'Lenovo', lastSeen: '2y ago', grade: 'Grade 4' },
  { imei: '86761506011738', name: 'Palesa Molefe', gender: 'Female', school: 'Soweto', circuit: 'Bogwasha', manufacturer: 'Asus', lastSeen: '1y ago', grade: 'Grade 5' },
  { imei: '86761506011739', name: 'Kabelo Mthethwa', gender: 'Female', school: 'Pretoria', circuit: 'Bogwasha', manufacturer: 'Apple', lastSeen: '4m ago', grade: 'Grade 2' },
  { imei: '86761506011740', name: 'Molemo Dube', gender: 'Male', school: 'Gauteng', circuit: 'Bogwasha', manufacturer: 'Microsoft', lastSeen: '3y ago', grade: 'Grade 3' },
  { imei: '86761506011741', name: 'Zanele Kaba', gender: 'Female', school: 'Durban', circuit: 'Bogwasha', manufacturer: 'Samsung', lastSeen: '1y ago', grade: 'Grade 6' },
  { imei: '86761506011742', name: 'Bofumelo Khumalo', gender: 'Female', school: 'Klerksdorp', circuit: 'Bogwasha', manufacturer: 'Toshiba', lastSeen: '5m ago', grade: 'Grade 1' },
  { imei: '86761506011744', name: 'Kagiso Mokoena', gender: 'Male', school: 'Johannesburg', circuit: 'Johannesburg', manufacturer: 'Huawei', lastSeen: '1y ago', grade: 'Grade 4' },
  { imei: '86761506011745', name: 'Nandi Dlamini', gender: 'Female', school: 'Cape Town', circuit: 'Cape Town', manufacturer: 'LG', lastSeen: '3m ago', grade: 'Grade 5' },
];

export const getDistrictData = (slug) => ({
  name: unslugify(slug),
  stats: [
    { label: 'Devices Deployed', value: '22,420', trend: '↑ 4212', trendSub: 'vs last month' },
    { label: 'Schools', value: '220', meta: 'across 16 circuits' },
    { label: 'Circuits', value: '16', meta: 'avg 5.9 schools each month' },
  ],
  carriers: CARRIERS,
  circuits: CIRCUITS,
  dataUsage: DATA_USAGE,
  devices: { total: 300, online: 200, offline: 100 },
  deviceDetails: DEVICE_DETAILS,
});
